<template>
  <div class="checklist-view-component-container">
    <page-header :breadcrumbs="[{ name: checklistName }]">
      <template #topbar>
        {{ checklistName }}
      </template>
    </page-header>
    <div class="list-container">
      <div class="list-heading row">
        <div class="task-heading">
          Task
        </div>
        <div class="completed-heading">
          Completed
        </div>
      </div>
      <list-row
        v-for="item in checklistItems"
        :key="item.id"
        :class="{completed: checklistItemCompleted(item)}"
        @row-clicked="handleRowClick(item)"
      >
        <div class="item-name">
          {{ item.displayName }}
        </div>
        <div class="check-container">
          <icon
            name="slim-check"
            :variant="checklistItemCompleted(item) ? '00b46d' : ''"
          />
        </div>
      </list-row>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import ListRow from '@components/ui/listRow';
import PageHeader from '@components/singletons/pageHeader';
import ChecklistMixin from '@/mixins/checklist';

export default {
  components: { Icon, ListRow, PageHeader },
  mixins: [ChecklistMixin],
  computed: {
    checklist() {
      return this.$store.getters['checklists/all'].find(c => c.id == this.$route.params.checklistId);
    },
    checklistName() {
      return this.checklist?.displayName;
    },
    checklistItems() {
      const items = this.checklist?.checklistItems || [];
      return items.sort((a, b) => a.sortOrder - b.sortOrder);
    },
  },
  methods: {
    handleRowClick(item) {
      this.sendAnalytics(item);
      const route = this.checklistItemRoute(item);
      this.$router.push(route);
    },
    sendAnalytics(item) {
      const navItem = this.$store.getters['navigationItems/navigationItems'][item.navigationItemId];
      this.$analytics.events.selectedChecklistItem({ name: item.displayName, destinationType: navItem?.destination, destinationId: navItem?.resourceId });
    },
  },
};
</script>

<style lang='scss' scoped>
.checklist-view-component-container {
  background: #EDF1F5;
  @include full-padding;

  .list-container {
    .item-name, .task-heading {
      flex: 1;
    }

    .completed-heading, .check-container {
      min-width: rem-calc(120);
      text-align: center;

      @include breakpoint(small) {
        min-width: auto;
      }
    }

    .check-container {
      img {
        width: rem-calc(14);
      }
    }

    .completed {
      cursor: default;

      .item-name {
        opacity: 0.5;
      }
    }
  }
}
</style>
